<template>
    <div class="tour-btn-container standard">
        <shake-animate>
            <template v-slot="shakeStyle">
                <span
                    class="btn-item save"
                    @click="onFavoriteClick"
                    v-if="info.listingStatus != 'Sold'"
                    :class="[
                        hasFavor ? 'active' : '',
                        !hasFavor && shakeStyle.animate
                    ]"
                >
                    <i class="iconfont icon-heart default"></i>
                    <i class="iconfont icon-heart-fill hover"></i>
                    <span class="btn-text">{{
                        $t('md-detail-info.save')
                    }}</span>
                </span>
            </template>
        </shake-animate>
        <!-- tour button  -->
        <span
            v-for="tour in tourBtnList"
            :key="[tour.text, tour.link].join('_')"
            class="btn-item virtual-tour"
        >
            <a
                href="javascript:;"
                @click="handleTour($event, tour)"
                rel="noopener noreferrer"
            >
                <i class="iconfont" :class="tour.icon"></i>
                <span class="btn-text">{{ tour.text }}</span>
            </a>
        </span>
    </div>
</template>

<script>
import TourBtnMediaMixin from '../../tourBtnMediaPopMixin.js';
import shakeAnimate from '../../shake-animate.vue';

export default {
    mixins: [TourBtnMediaMixin],
    inject: ['onFavoriteClick'],
    data: function() {
        return {};
    },
    components: { shakeAnimate }
};
</script>

<style lang="scss">
.tour-btn-container.standard {
    width: 30%;
    display: flex;
    justify-content: flex-end;
    .btn-item {
        text-align: center;
        cursor: pointer;
        margin-left: 20px;
        width: 33.33%;
        color: #33cf81;
        &.save {
            color: #f0454c;
            .hover {
                display: none;
            }
            &.active,
            &:hover {
                .default {
                    display: none;
                }
                .hover {
                    display: block;
                }
            }
        }
        .iconfont {
            font-size: 20px;
            display: block;
            line-height: 30px;
        }
        .btn-text {
            font-size: 14px;
            color: var(--color-disable);
        }
        &:last-child {
            margin-right: 0;
        }
    }
}
@media (max-width: 600px) {
    .tour-btn-container.standard {
        width: 30%;
        display: flex;
        justify-content: flex-end;
        .btn-item {
            text-align: center;
            cursor: pointer;
            margin-right: 15px;
            color: #33cf81;
            &.save {
                color: #f0454c;
            }
            .iconfont {
                font-size: 18px;
                display: block;
                line-height: 30px;
            }
            .btn-text {
                font-size: 12px;
                color: var(--color-disable);
            }
        }
    }
}
</style>
